import { render } from "./RecordAssessment.vue?vue&type=template&id=f302d2fe"
import script from "./RecordAssessment.vue?vue&type=script&lang=js"
export * from "./RecordAssessment.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src766051562/src/medoor-medical-records/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__